// Mock data for Mon Evénemenciel website clone

export const siteConfig = {
  name: "Mon Evénemenciel",
  tagline: "L'art de vous rassembler",
  logoUrl: "/img/logo-me-couleur.png",
  logoUrlLight: "/img/logo-me-blanc.png",
  moonUrl: "/img/logo-me-blanc.png",
  heroImage: "/img/photo-accueil-mon-evenemenciel.webp",
  colors: {
    primary: "#96452f",
    secondary: "#D08154",
    dark: "#082938",
    light: "#FEFDFA",
    white: "#FFFFFF"
  }
};

export const navigation = [
  { name: "Accueil", path: "/" },
  { name: "Qui sommes nous ?", path: "/qui-sommes-nous" },
  { name: "Le Groupe", path: "/groupe" },
  { name: "Notre offre", path: "/notre-offre" },
  { name: "Contact", path: "/contact" }
];

export const homeStats = [
  {
    value: "+55%",
    label: "de collaborateurs + créatifs",
    icon: "lightbulb"
  },
  {
    value: "+23%",
    label: "des jeunes actifs sont attirés par une entreprise fun",
    sublabel: "« attirer des talents »",
    icon: "smile"
  },
  {
    value: "+95%",
    label: "des dirigeants & collaborateurs estiment que cela rend + performants",
    icon: "trending-up"
  }
];

export const clientLogos = [
  { name: "fagerhult", url: "/img/logo-ref-fagerhult.svg" },
  { name: "LDLC", url: "/img/logo-ref-groupe-ldlc.jpg" },
  { name: "homeserve", url: "/img/logo-ref-homeserve.png" },
  { name: "intitek", url: "/img/logo-ref-intitek.png" },
  { name: "laposte", url: "/img/logo-ref-laposte.svg" },
  { name: "aldes", url: "/img/logo-ref-aldes.png" },
  { name: "assystem", url: "/img/logo-ref-assystem.png" },
  { name: "bymycar", url: "/img/logo-ref-bymycar.png" },
  { name: "covivio", url: "/img/logo-ref-covivio.png" },
  { name: "credit-agricole", url: "/img/logo-ref-credit-agricole.png" },
  { name: "dupont-restauration", url: "/img/logo-ref-dupont-restauration.jpg" },
  { name: "enedis", url: "/img/logo-ref-enedis.png" },
  { name: "LOU Rugby", url: "https://customer-assets.emergentagent.com/job_clonevenement/artifacts/7edl26rq_Lyon_olympique_universitaire.svg" },
  { name: "EM Lyon", url: "https://customer-assets.emergentagent.com/job_clonevenement/artifacts/20aj3svm_Logo_emlyon_2021.png" },
  { name: "Malakoff Humanis", url: "https://customer-assets.emergentagent.com/job_clonevenement/artifacts/157eiveo_malakoffhumanis-2025-070-logo-malakoff-humanis-400x255.png.webp" },
  { name: "EDF", url: "https://customer-assets.emergentagent.com/job_clonevenement/artifacts/75u12yjn_Logo-EDF.png" },
  { name: "April", url: "https://customer-assets.emergentagent.com/job_clonevenement/artifacts/8c6k71he_images.png" }
];

export const historyTimeline = [
  {
    year: "2017",
    title: "La belle histoire débute et on ne le savait pas encore !",
    description: "Notre client et partenaire GROUPE LDLC demande à MA CONCIERGERIE d'organiser et d'animer tous les jeudis soirs les afterworks. Ces événements se déroulent sur le lieu de travail de 18h à 21h afin de créer du lien & fédérer les équipes."
  },
  {
    year: "de 2017 à 2019",
    title: "D'afterworks en afterworks, de soirées en soirées, d'animation...",
    description: "Les afterworks se multiplient, se transforment, se professionnalisent et le constat est clair : LES COLLABORATEURS ECHANGENT, FONT CONNAISSANCE, SE LIENT ! Ils ont plaisir à se retrouver, c'est une parenthèse pour souffler et décompresser."
  },
  {
    year: "2019 et au-delà",
    title: "On officialise !",
    description: "Mon EvénemenCiel est créée avec comme grande sœur Ma Conciergerie pour l'épauler et la faire bien grandir ! L'offre se diversifie, les clients la sollicitent comme levier de bien-être en entreprise."
  },
  {
    year: "Avril 2024",
    title: "Prise de fonction d'Alexis RAUSCH",
    description: "Une nouvelle page s'écrit pour Mon Evénemenciel ! Alexis RAUSCH, fort de ses 8 années d'expérience au sein du Groupe Ma Conciergerie, prend les rênes en tant que Directeur Général. Son énergie, sa connaissance du terrain et sa vision ambitieuse insufflent un nouvel élan à l'entreprise. Aux côtés de Christophe GARNIER, il porte haut les valeurs humaines qui font notre ADN."
  },
  {
    year: "2024 à aujourd'hui",
    title: "Une offre professionnelle à l'échelle nationale",
    description: "Mon Evénemenciel franchit un cap décisif en structurant son offre pour répondre aux exigences des grandes entreprises. L'équipe s'étoffe, les process se professionnalisent et notre présence s'étend désormais sur l'ensemble du territoire français. De Lyon à Paris, nous accompagnons nos clients partout en France avec la même passion et le même engagement."
  }
];

export const agitateurs = [
  {
    name: "Alexis RAUSCH",
    role: "Directeur Général",
    image: "/img/photo-portrait-alexis-rausch.jpg",
    description: "Après avoir étudié au sein du lycée hôtelier François Rabelais de Lyon, Alexis Rausch a débuté sa carrière dans le domaine de la restauration. En 2017, il a rejoint Ma Conciergerie en tant que concierge, débordant d'enthousiasme, d'envie et de bonne humeur. Aujourd'hui, Alexis s'associe à Christophe GARNIER et devient le Directeur Général de MON EVENEMENCIEL."
  },
  {
    name: "Christophe GARNIER",
    role: "Fondateur",
    image: "/img/photo-portrait-christophe-garnier-2.jpg",
    description: "Né d'une famille d'entrepreneurs, il croit en l'esprit d'entreprise, en la capacité des personnes à créer et porter des projets. Son parcours professionnel lui donne le sens du service, du commerce et de l'approche client."
  }
];

export const groupeCompanies = [
  {
    name: "PRYSME LE GROUPE",
    subtitle: "L'art de vivre professionnel",
    logo: "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/6upn3okn_logo-prysme-couleur.png",
    description: "Le Groupe Prysme incarne l'art de vivre professionnel en plaçant l'Humain, la convivialité et l'audace au cœur de son action. À travers ses cinq marques fortes, il propose des services complémentaires et pleins de sens.",
    link: "https://prysme.eu"
  }
];

export const chaineVertueuse = {
  intro: "Le groupe joue à 6 mains la même partition, avec pour ambition l'amélioration de l'environnement de travail. C'est ainsi qu'en alliant les compétences de tous on contribue à changer la vision de tous sur le monde du travail.",
  sections: [
    {
      company: "Mon Evénemenciel",
      logo: "/img/logo-monevenemenciel.svg",
      items: [
        { title: "INCLUSION & COHESION", subtitle: "afterworks, soirées - tempo annuel ou à la carte" },
        { title: "CONVIVIALITE", subtitle: "animations ludiques - ateliers collaboratifs" },
        { title: "GREATWASHING", subtitle: "team-building - challenges sportifs – culturels" },
        { title: "AMENAGEMENTS DES ESPACES", subtitle: "espaces ludiques & récréatifs" }
      ]
    },
    {
      company: "Ma Conciergerie",
      logo: "/img/logo-maconciergerie.svg",
      link: "https://www.maconciergerie.eu/",
      items: [
        { title: "ENGAGEMENT RSE", subtitle: "actions solidaires & sociales" },
        { title: "EQUILIBRE VIE PRO/VIE PERSO", subtitle: "+ de 120 services pour soulager le collaborateur" },
        { title: "INTEGRATION DU HANDICAP", subtitle: "conciergerie solidaire" }
      ]
    },
    {
      company: "Ma Capsule",
      logo: "/img/logo-macapsule.svg",
      link: "https://www.macapsule.eu/",
      items: [
        { title: "RECOMPENSES", subtitle: "club avantages billetterie, vacances" },
        { title: "EVEIL FORMATION", subtitle: "capsules thématiques" },
        { title: "SANTE AU TRAVAIL", subtitle: "+ de 20 praticiens santé" },
        { title: "BIEN-ETRE", subtitle: "+ de 50 thèmes de cours collectifs" }
      ]
    }
  ]
};

export const focusServices = [
  { 
    icon: "glass", 
    title: "Moments Festifs",
    items: ["Afterworks & soirées", "Petits-déjeuners d'accueil", "Cocktails & buffets", "Inaugurations"],
    images: [
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/okzlv5fn_Bar%20%C3%A0%20cocktail.jpg",
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/09hk0yky_Inauguration%20EM.jpg"
    ]
  },
  { 
    icon: "gallery", 
    title: "Marchés & Expos",
    items: ["Marché de Noël", "Marché gourmand", "Marché artisanal", "Expo pop-up d'artistes"],
    images: [
      "https://images.pexels.com/photos/716658/pexels-photo-716658.jpeg?auto=compress&cs=tinysrgb&w=800",
      "https://images.pexels.com/photos/3184188/pexels-photo-3184188.jpeg?auto=compress&cs=tinysrgb&w=800"
    ]
  },
  { 
    icon: "team", 
    title: "Team Building",
    items: ["Défis collaboratifs", "Animations ludiques", "Escape games", "Jeux géants"],
    images: [
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/0aepf87y_Capture%20d%27%C3%A9cran%202026-01-08%20090653.png",
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/g0tsh37u_Capture%20d%27%C3%A9cran%202026-01-08%20090703.png",
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/jjtxarsz_Capture%20d%27%C3%A9cran%202026-01-08%20090633.png"
    ]
  },
  { 
    icon: "challenge", 
    title: "Challenges & Ateliers",
    items: ["Challenges sportifs", "Défis culturels", "Ateliers culinaires", "Sessions créatives"],
    images: [
      "https://images.pexels.com/photos/7988219/pexels-photo-7988219.jpeg",
      "https://images.unsplash.com/photo-1507048331197-7d4ac70811cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjb29raW5nJTIwd29ya3Nob3B8ZW58MHx8fHwxNzY3ODYyMDcwfDA&ixlib=rb-4.1.0&q=85"
    ]
  },
  { 
    icon: "artiste", 
    title: "Artistes & Performers",
    items: ["Musiciens live", "Impros & spectacles", "Performers", "Animations artistiques"],
    images: [
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/qiwgf0ty_image.png",
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/th991hf4_Fetes%20de%20la%20musique%20ENEDIS%203%20%281%29.jpg"
    ]
  },
  { 
    icon: "noel", 
    title: "Événements Famille",
    items: ["Arbre de Noël", "Family Day", "Fêtes enfants", "Moments intergénérationnels"],
    images: [
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/nq1506fy_image.png",
      "https://customer-assets.emergentagent.com/job_evenciel-replica/artifacts/d6jhbx65_image.png"
    ]
  }
];

export const tempoEvents = [
  {
    month: "Août",
    title: "Le repos des Héros",
    description: "Envoie une carte postale A ta boîte Prix du + créatif...",
    image: "/img/photo-tempo-aout.jpg"
  },
  {
    month: "Septembre",
    title: "Réveille ta journée !",
    description: "Back to work Distribution de fruits frais & réveille ton cerveau Casse tête - énigme",
    image: "/img/photo-tempo-septembre.jpg"
  },
  {
    month: "Octobre",
    title: "Parenthèse méridienne",
    description: "Pause gaufres Le combat des super-héros",
    image: "/img/photo-tempo-octobre.jpg"
  },
  {
    month: "Novembre",
    title: "Parenthèse méridienne",
    description: "Candy bar effrayant Parcours 5 sens",
    image: "/img/photo-tempo-novembre.jpg"
  },
  {
    month: "Décembre",
    title: "Afterwork",
    description: "Soirée saucisson chaud et pdt Vin chaud & marrons grillés Caricaturiste et frise collective",
    image: "/img/photo-tempo-decembre.jpg"
  },
  {
    month: "Janvier",
    title: "Paraenthèse méridienne",
    description: "Venez tirer les rois & partagez une bolée de cidre Défi les jeux du fort",
    image: "/img/photo-tempo-janvier.jpg"
  },
  {
    month: "Février",
    title: "Afterwork",
    description: "Tartiflette géante Jeux géants et collaboratifs en bois",
    image: "/img/photo-tempo-fevrier.jpg"
  },
  {
    month: "Mars",
    title: "Parenthèse méridienne",
    description: "Pause crêpes Atelier initiation impro & cohésion",
    image: "/img/photo-tempo-mars.jpg"
  },
  {
    month: "Avril",
    title: "Réveille ta journée !",
    description: "Accueil café & viennoiseries et fruit frais Parcours déroutant",
    image: "/img/photo-tempo-avril.jpg"
  },
  {
    month: "Mai",
    title: "Parenthèse méridienne",
    description: "Pause vitaminée jus de fruits frais à composer Blind test musical",
    image: "/img/photo-tempo-mai.jpg"
  },
  {
    month: "Juin",
    title: "Afterwork",
    description: "Summer party BBQ & atelier mojito Tournois pétanque ; palets bretons ; Mölky",
    image: "/img/photo-tempo-juin.jpg"
  },
  {
    month: "Juillet",
    title: "Parenthèse méridienne",
    description: "Pause glacée, distribution de glaces artisanales Atelier DO IN auto-massage",
    image: "/img/photo-tempo-juillet.jpg"
  }
];

export const footerLinks = {
  social: [
    { name: "LinkedIn", url: "#" },
    { name: "Instagram", url: "#" },
    { name: "Facebook", url: "#" }
  ],
  legal: [
    { name: "Mentions légales", path: "/mentions-legales" },
    { name: "Politique de confidentialité", path: "/confidentialite" }
  ],
  contact: {
    email: "contact@monevenemenciel.eu",
    phone: "+33 (0)4 XX XX XX XX"
  }
};

/** Landing pages SEO (intention de recherche) */
export const serviceLandings = {
  "team-building": {
    slug: "team-building",
    path: "/team-building",
    navLabel: "Team building",
    heroTitle: "Team building entreprise",
    heroSubtitle: "Des expériences collaboratives qui créent du lien",
    heroImage: "/img/photo-groupe.webp",
    seoTitle: "Team building entreprise Lyon | Cohésion d'équipe",
    seoDescription:
      "Organisez un team building sur mesure à Lyon et en France avec Mon Evénemenciel : défis collaboratifs, escape games, jeux géants et animations ludiques pour fédérer vos équipes.",
    seoKeywords:
      "team building Lyon, team building entreprise, cohésion équipe, escape game entreprise, animation collaborative, Mon Evénemenciel",
    introTitle: "Fédérer sans forcer le fun",
    introText: [
      "Un team building réussi ne se résume pas à une activité « gadget ». Chez Mon Evénemenciel, nous concevons des expériences collaboratives adaptées à votre culture d'entreprise, à vos objectifs RH et au rythme de vos collaborateurs.",
      "Défis d'équipe, escape games, jeux géants ou animations ludiques : chaque format est pensé pour faire émerger la coopération, la créativité et… le plaisir de travailler ensemble."
    ],
    benefits: [
      { title: "Sur mesure", text: "Thème, durée et intensité adaptés à vos équipes et à vos locaux." },
      { title: "Clé en main", text: "Conception, communication interne, animation et gestion du jour J." },
      { title: "Impact durable", text: "Des souvenirs partagés qui renforcent la cohésion au quotidien." }
    ],
    offerings: [
      "Défis collaboratifs",
      "Animations ludiques",
      "Escape games",
      "Jeux géants",
      "Ateliers créatifs & impro"
    ],
    faq: [
      {
        q: "Pour combien de collaborateurs ?",
        a: "Nous adaptons le format de quelques dizaines à plusieurs centaines de participants, sur site ou hors les murs."
      },
      {
        q: "Intervenez-vous hors de Lyon ?",
        a: "Oui. Basés en Auvergne-Rhône-Alpes, nous organisons des team buildings sur l'ensemble du territoire français."
      }
    ],
    ctaLabel: "Demander un devis team building"
  },
  afterwork: {
    slug: "afterwork",
    path: "/afterwork",
    navLabel: "Afterwork",
    heroTitle: "Afterwork & soirées d'entreprise",
    heroSubtitle: "La parenthèse qui rapproche les équipes",
    heroImage: "/img/photo-evenement.webp",
    seoTitle: "Afterwork entreprise Lyon | Soirées & cocktails",
    seoDescription:
      "Afterworks, cocktails et soirées d'entreprise organisés de A à Z par Mon Evénemenciel à Lyon et en France. Créez du lien après le travail, sans charge mentale.",
    seoKeywords:
      "afterwork entreprise Lyon, soirée entreprise, cocktail entreprise, animation afterwork, Mon Evénemenciel",
    introTitle: "Après le travail, le vrai lien commence",
    introText: [
      "L'afterwork est souvent le moment où les silos tombent. Nous imaginons des formats chaleureux — cocktails, buffets, animations légères — pour que vos collaborateurs se retrouvent autrement.",
      "Ponctuel ou inscrit dans un calendrier annuel (Tempo), chaque afterwork est orchestré pour que vous profitiez… pendant que nous gérons le reste."
    ],
    benefits: [
      { title: "Ambiance soignée", text: "Scénographie, catering et animation alignés sur votre image." },
      { title: "Sans charge mentale", text: "De la logistique à l'accueil des prestataires, on s'occupe de tout." },
      { title: "Récurrent ou one-shot", text: "Une soirée signature ou un rythme mensuel / trimestriel." }
    ],
    offerings: [
      "Afterworks & soirées",
      "Cocktails & buffets",
      "Petits-déjeuners d'accueil",
      "Inaugurations",
      "Animations live (musique, impro…)"
    ],
    faq: [
      {
        q: "Pouvez-vous intervenir dans nos locaux ?",
        a: "Oui, la plupart de nos afterworks se déroulent sur le lieu de travail. Nous pouvons aussi proposer des lieux partenaires."
      },
      {
        q: "Quel délai pour organiser un afterwork ?",
        a: "Selon le format, comptez de quelques semaines à deux mois pour un événement pleinement maîtrisé."
      }
    ],
    ctaLabel: "Organiser un afterwork"
  },
  "seminaire-entreprise": {
    slug: "seminaire-entreprise",
    path: "/seminaire-entreprise",
    navLabel: "Séminaire",
    heroTitle: "Séminaire d'entreprise",
    heroSubtitle: "Temps forts professionnels, énergie collective",
    heroImage: "/img/photo-focus.webp",
    seoTitle: "Séminaire entreprise Lyon | Organisation clé en main",
    seoDescription:
      "Organisation de séminaires d'entreprise à Lyon et en France : cadrage, animation, catering et déroulé du jour J avec Mon Evénemenciel. Un temps fort utile et mémorable.",
    seoKeywords:
      "séminaire entreprise Lyon, organisation séminaire, séminaire offsite, animation séminaire, Mon Evénemenciel",
    introTitle: "Un séminaire qui sert vraiment vos objectifs",
    introText: [
      "Réunion stratégique, kick-off annuel ou offsite de cohésion : le séminaire doit allier fond et forme. Nous vous aidons à bâtir un déroulé clair, rythmé, et une expérience qui motive vos équipes.",
      "De la définition du projet à la clôture, notre méthode « de A à Z » vous laisse concentrés sur le contenu — pendant que nous orchestrons le cadre."
    ],
    benefits: [
      { title: "Déroulé maîtrisé", text: "Timing, transitions et animation pour tenir vos objectifs." },
      { title: "Expérience mémorable", text: "Moments fédérateurs sans dénaturer le sérieux du sujet." },
      { title: "Un seul interlocuteur", text: "Lieu, catering, technique et animation coordonnés." }
    ],
    offerings: [
      "Kick-off & conventions",
      "Séminaires stratégiques",
      "Offsites cohésion",
      "Ateliers & challenges",
      "Soirée de clôture"
    ],
    faq: [
      {
        q: "Gérez-vous aussi le lieu ?",
        a: "Nous pouvons travailler dans vos locaux ou vous accompagner dans le choix et la coordination d'un lieu partenaire."
      },
      {
        q: "Proposez-vous des formats hybrides ?",
        a: "Oui, selon vos besoins : présentiel, séquences digitales ou formule mixte."
      }
    ],
    ctaLabel: "Planifier un séminaire"
  }
};

export const serviceLandingList = Object.values(serviceLandings);

